export default __webpack_public_path__ + "static/media/dark_small.9eae121e.png";